exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-tabs {\r\n  background-color: white;\n}\n.tab-content {\r\n  margin-top: 0 !important;\n}\r\n", ""]);

// exports
